module.exports = __webpack_public_path__ + "img/pageTop.569a1bb7.svg";